import React from 'react'
import './index.less'
import cx from 'classnames'
import noList from '@/assets/images/jingqingqidai.png'
import { device } from '../../../assets/js/utils'
class DebtTransfer extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isLogin: false
        }
    }

    componentDidMount () {
        if (device.isGomePlus) {
            window.GomeJSBridge.isLogin((data) => {
                if (data.isLogined === 'Y') {
                    this.setState({
                        isLogin: true
                    })
                }
            }, (data) => {
                this.setState({
                    isLogin: false
                })
            })
        }
    }

    // 跳转债转业务
    toGs = (item) => {
        const { buriedPointEvent, data: { position, trackId, sublist: [{ id }] } } = this.props
        buriedPointEvent({
            button_name: `${trackId}`,
            button_id: `${id}`,
            button_order: '1',
            area_order: position,
            button_area: `${position}-${trackId}`
        })
        const activityNo = this.props.data.sublist[0].bannerList[0].activityNo
        const HTML_LINK = process.env.REACT_APP_HTML_LINK
        // const pageLink = item !== 'gsindex' ? `${HTML_LINK}gs-detail?activityNo=${activityNo}&packageNo=${item.packageNo}` : `${HTML_LINK}gs-index?activityNo=${activityNo}`
        const pageLink = `${HTML_LINK}gs-index?activityNo=${activityNo}`
        window.GomeJSBridge.pushWindow(null, null, pageLink)
    }

    render () {
        const { data: { sublist: [{ list = [], resultFlag }] } } = this.props
        return (list && list.length) ? (
            <div className={cx('debtTransferContainer', this.state.isLogin ? 'isLogined' : null)}>
                <div
                    className={'debtTransferTop statistics-dom'}
                    onClick={() => {
                        this.toGs('gsindex')
                    }}
                > </div>
                <div className={'debtProductContainer'}>
                    <ul className='debtProductContainerUl'>
                        {
                            list.map((item, index) => {
                                return (
                                    <li className={'debtProductItem'} key={index}>
                                        <p>
                                            <span>{item.packageRate}</span>
                                            <span>{item.packageRateUnit}</span>
                                        </p>
                                        <p>最高年化收益</p>
                                        {(item.activitTitleyArray.length > 0 && item.activitTitleyArray[0].atShortName) && <i className="debt-ico">{item.activitTitleyArray[0].atShortName.slice(0, 2)}</i>}
                                        <div
                                            className="btn-wrap statistics-dom"
                                            onClick={() => this.toGs(item)}
                                        >
                                            {(item.assetStat === 'assetStat_001') && (<div className="btn">{item.beginTime}开抢</div>)}
                                            {(item.assetStat === 'assetStat_002') && (<div className="btn">立即投资</div>)}
                                            {(item.assetStat === 'assetStat_003') && (<div className="btn">还有机会</div>)}
                                            {(item.assetStat === 'assetStat_004') && (<div className="btn">立即预约</div>)}
                                            {(item.assetStat === 'assetStat_005') && (<div className="btn-no">已售罄</div>)}
                                            {(item.assetStat === 'assetStat_006') && (<div className="btn-no">已结束</div>)}
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    {(list.length === 1) && (
                        <div className="comming-wrap">
                            <li className="comming-soon debtProductItem"></li>
                            <li className="comming-soon debtProductItem"></li>
                        </div>
                    )}
                    {(list.length === 2) && (
                        <div className="comming-wrap">
                            <li className="comming-soon debtProductItem"></li>
                        </div>
                    )}
                </div>
            </div>
        ) : (resultFlag === 'Y' && (
            <div
                className='noList'
                onClick={() => this.toGs('gsindex')}
            >
                <img alt="" src={noList} />
            </div>
        ))
    }
}

export default DebtTransfer
